export const agents = [
  {
    key: "support",
    name: "Support",
    icon: "◎",
    description: "A helpful answer, whenever it's needed.",
  },
  {
    key: "sales",
    name: "Sales",
    icon: "↗",
    description: "The right products for the right person.",
  },
  {
    key: "conversion",
    name: "Conversion",
    icon: "◇",
    description: "A thoughtful offer, within your rules.",
  },
  {
    key: "insights",
    name: "Insights",
    icon: "✧",
    description: "Useful lessons from customer conversations.",
  },
] as const;

export const movieScenes = [
  {
    title: "A question starts the conversation",
    agents: [0],
    tab: "ai-rep",
    duration: 1700,
    detail: "Support picks up a shopper's question, right inside Buddy.",
  },
  {
    title: "A helpful answer, grounded in your store",
    agents: [0],
    tab: "ai-rep",
    duration: 2400,
    detail:
      "Buddy answers with product information and keeps the conversation moving.",
  },
  {
    title: "The right product enters the picture",
    agents: [1],
    tab: "ai-rep",
    duration: 2400,
    detail: "Sales takes the shopper's needs and finds something that fits.",
  },
  {
    title: "A little flexibility makes a difference",
    agents: [2],
    tab: "ai-rep",
    duration: 2800,
    detail:
      "Conversion brings an eligible offer into the journey, within your rules.",
  },
  {
    title: "Discovery opens up the catalog",
    agents: [1],
    tab: "home",
    duration: 2100,
    detail:
      "The shopper explores the collection and chooses the Everyday Weekender.",
  },
  {
    title: "A closer look at the product",
    agents: [1],
    tab: "home",
    duration: 1800,
    detail: "The product, the offer, and a way to ask Buddy — all connected.",
  },
  {
    title: "One last question, with context",
    agents: [0],
    tab: "ai-rep",
    duration: 2700,
    detail:
      "Buddy knows which product they mean, so they don't have to start over.",
  },
  {
    title: "From cart to checkout, together",
    agents: [1, 2],
    tab: "cart",
    duration: 3600,
    detail:
      "Sales adds the right product; Conversion carries the offer through to checkout.",
  },
  {
    title: "Every conversation has something to teach",
    agents: [3],
    tab: "ai-rep",
    duration: 3000,
    detail:
      "Insights reviews the journey and spots a useful product detail to improve.",
  },
  {
    title: "Four specialties. One Buddy.",
    agents: [0, 1, 2, 3],
    tab: "ai-rep",
    duration: 2500,
    detail:
      "Support, discovery, conversion, and insight — connected around your store.",
  },
];
export const STORY_DURATION_MS = movieScenes.reduce(
  (sum, scene) => sum + scene.duration,
  0,
);
export function storySceneAt(elapsed: number) {
  let end = 0;
  const index = movieScenes.findIndex((scene) => {
    end += scene.duration;
    return elapsed < end;
  });
  return index < 0 ? movieScenes.length - 1 : index;
}
export function storySceneStart(index: number) {
  return movieScenes
    .slice(0, index)
    .reduce((sum, scene) => sum + scene.duration, 0);
}
